<template>
	<div class="pages">
		<div v-for='(item, index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control == "Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control == "Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control == "Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control == "Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control == "Money"' :data-val="item"></Money>
			<!--			<Counter v-if='item.Property.Control=="Number"' :data-val="item"></Counter>-->
			<Tips v-if='item.Property.Control == "Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control == "File"' :data-val="item"></File>
			<Table v-if='item.Property.Control == "Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control == "Selector"' @child-event='getSelectorVal' :data-val='item'>
			</Selector>
			<Textarea v-if='item.Property.Control == "Textarea"' :data-val='item'></Textarea>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
/**
 * Version 为Text文本组件
 */
import Digit from '../components/Number.vue'
import Contact from '../components/Contact.vue';
import Dates from '../components/Date.vue';
import Version from '../components/Text.vue';
import Money from '../components/Money.vue';
import Counter from "../components/Counter.vue";
import Tips from '../components/Tips.vue';
import File from '../components/File.vue';
import Table from '../components/Table.vue?v=3';
import Selector from '../components/Selector.vue';
import Textarea from '../components/Textarea.vue';
import wx from 'weixin-js-sdk'

// import {
// 	initWxConfig
// } from "../api/jssdk.js";
import stringUtils from "../assets/js/stringUtil.js";
import {
	getOptionValForDataVal,
	getChildrenForTable,
	getChildValueForTemplate,
	distinct,
	arrayIsEmpty
} from '@/utils/componentUtils.js'

var template = {
	TemplateContent: {
		Controls: []
	}
};

import {
	getTemplateInfo,
	submitProcess
} from '@/api/approval'

import {
	getRelation
} from '@/api/employee'

var isSubmit = false;

export default {
	components: {
		Contact,
		Dates,
		Version,
		// Counter,
		Digit,
		Tips,
		File,
		Table,
		Money,
		Selector,
		Textarea
	},
	data() {
		return {
			templateData: template,
			relationList: null,
			logInfo: null,
			templateId: "",
			spNo: null,
			listLoading: false,
			isDisabled: false
		}
	},
	mounted() { //页面挂载
		this.logInfo = this.getLoginUserInfo();
		this.templateId = this.$route.query.templateId;
		this.spNo = this.$route.query.spNo;
		this.getTemplate();
		stringUtils.setAddIsShow(true);
	},
	methods: { //方法
		getTemplate: async function () {
			await this.getEmployeeRelation(this.logInfo.EmpNo);
			var that = this;
			getTemplateInfo(this.templateId).then(async response => {
				var controls = response.Body;
				let TempControls = controls.TemplateContent.Controls
				controls.TemplateContent.Controls.forEach(async (item) => {
					if (item.Property.Title[0].Text === "资质") {
						let numCom = item.Config.Table.Children.filter(e => e.Property.Title[0].Text === "份数");
						console.log(numCom);
					}
					if (item.Property.Title[0].Text == "流程条件") {
						item.Value = this.logInfo.JobLevel <= 8 ? 1 : 2
					}
					if (item.Property.Title[0].Text == "逐级审批使用") {
						item.Values = await this.getRelationList(this.relationList, 8);
						let deptName = that.logInfo.DeptName;
						let fullName = that.logInfo.fullName;
						if(deptName && (deptName.indexOf("藤云")>-1 || deptName.indexOf("房友圈")>-1)){
							item.Values.push(["SC03080007", "徐菁"])
						}
						//非营业部/二级市场支援中心 袁诚  部门：行政支持组 领导审批缺失，指定 陈相云 审批
						if(item.Values.length<=0 &&fullName && fullName.indexOf("非营业部/二级市场支援中心")>-1 ){
							item.Values.push(["SC23000441", "陈相云"])
						}
						//如果都没有人，最后处理
						if(item.Values.length<=0 ){
							item.Values.push(that.$store.state.defaultMember);
						}
					}
				});
				this.templateData = this.assignControl(controls, this.logInfo);
				this.templateData = await this.assignControlBySpNo(controls, this.spNo);
				this.listLoading = false;
			});
		},
		getTextVal() { },
		getSelectorVal(val, name) {
			var type = "";
			var y = 0;
			var children = "";
			if (name == "借用类型") {
				var controls = this.templateData.TemplateContent.Controls;
				for (var i = 0; i < controls.length; i++) {
					if (controls[i].Property.Title[0].Text == name) {
						var options = controls[i].Config.Selector.Options;
						for (var j = 0; j < options.length; j++) {
							if (options[j].Key == val) {
								type = options[j].Value[0].Text;
							}
						}
					} else if (controls[i].Property.Title[0].Text.indexOf("印章") > -1) {
						if (type == "原件") {
							// controls[i].IsShow = true;
							this.$set(controls[i], 'IsShow', true)
							children = controls[i].Config.Table.Children;
							for (y = 0; y < children.length; y++) {
								if (children[y].Value == null) {
									children[y].Value = '';
								} else {
									children[y].Value = null;
								}
								children[y].Property.Require = 0;
							}
						} else if (type === "复印件" || type === "电子版") {
							// controls[i].IsShow = false;
							this.$set(controls[i], 'IsShow', false)
							children = controls[i].Config.Table.Children;
							for (y = 0; y < children.length; y++) {
								if (children[y].Value == null) {
									children[y].Value = '';
								} else {
									children[y].Value = null;
								}
								children[y].Values = null;
								children[y].Property.Require = 0;
							}
						}
					}
					else if (controls[i].Property.Title[0].Text == '预计领取时间' || controls[i].Property.Title[0].Text == '预计归还时间') {
						if (type == "原件") {
							this.$set(controls[i], 'IsShow', true)
						}else{
							this.$set(controls[i], 'IsShow', false)
						}
					}
				}
			}
			this.$forceUpdate()
		},
		getEmployeeRelation: async function (empNo) {
			await getRelation(empNo).then(response => {
				this.relationList = response.Body[0].Nodes;
			});
		},
		tableOperation(val, type, datas) {
			this.tableoperation(val, type, datas, this);
		},
		getApprovalCriteria(templateContent) {
			const controls = templateContent.Controls
			// 是否为非原件
			let nonOriginal = false
			// 是否包含分行
			let isIncludeBranch = false
			// 是否仅分行
			let isOnlyBranch = false
			// 公司印章是否填写
			let isCompanySeal = false
			// 资质模块是否填写
			let isCompanyQualification = false
			// 获取借用类型
			let borrowingType = controls.filter(e => e.Property.Title[0].Text === "借用类型")[0]
			const borrowingTypeString = getOptionValForDataVal(borrowingType.Value, borrowingType)
			nonOriginal = borrowingTypeString !== "原件"
			let childValues = getChildValueForTemplate(controls, "资质", "公司", "Value", true)
			// 判断是否选择了公司 == 是否填写了资质模块
			isCompanyQualification = childValues.filter(e => e !== null && e !== undefined).length > 0
			childValues = distinct(childValues)
			// 判断是否仅分行
			isOnlyBranch = childValues.filter(e => e !== "分行").length === 0
			isIncludeBranch = childValues.includes("分行")
			// 判断是否包含公司印章
			let childSealValues = getChildValueForTemplate(controls, "印章", "公司", "Value", true)
			isCompanySeal = childSealValues.filter(e => e !== null && e !== undefined).length > 0

			// 1 -> 选择了复印件、电子版 + 资质文件借用不含分行
			// 2 -> 选择了复印件、电子版 + 资质文件借用包含分行
			if (nonOriginal) {
				if (!isIncludeBranch) {
					console.log("1 -> 选择了复印件、电子版 + 资质文件借用不含分行")
					return 1
				}
				let includeBranchForValue = []
				// 分 三块
				for (const control of controls.filter(e => e.Property.Title[0].Text.indexOf("资质") > -1)) {
					const children = control.Config.Table.Children
					const companyChild = children.filter(e => e.Property.Title[0].Text === "公司")[0]
					let companyCheckedName = getOptionValForDataVal(companyChild.Value, companyChild)
					if (companyCheckedName === "分行") {
						const typeChild = children.filter(e => e.Property.Title[0].Text === "类型")[0]
						if (arrayIsEmpty(typeChild.ValuesSelect)) {
							continue
						}
						const options = typeChild.Config.Selector.Options.filter(e => e.IsShow)
						options.forEach(option => {
							typeChild.ValuesSelect.forEach(typeValue => {
								if (option.Key == typeValue) {
									includeBranchForValue.push(option.Value[0].Text)
								}
							})
						})
					}
				}
				let distinctValues = distinct(includeBranchForValue);
				// 判断是否无营业执照
				if (distinctValues.filter(e => e == "营业执照").length <= 0) {
					console.log("3 -> 选择了复印件、电子版 + 资质文件借用包含分行 + 无营业执照")
					return 3
				}
				// 判断是否仅营业执照
				if (distinctValues.filter(e => e != "营业执照").length === 0) {
					console.log("2 -> 选择了复印件、电子版 + 资质文件借用包含分行 + 仅营业执照")
					return 2
				}
				console.log("4 -> 选择了复印件、电子版 + 资质文件借用包含分行 + 包含营业执照")
				return 4
			}

			// 6 -> 选择了原件 + 公司印章
			if (!isCompanyQualification && isCompanySeal) {
				// 资质未填写 且 印章填写了
				console.log("6 -> 选择了原件 + 公司印章")
				return 6
			}

			// 5 -> 选择了原件 + 资质 非分行
			if (!isIncludeBranch && !isCompanySeal) {
				console.log("5 -> 选择了原件 + 资质 非分行")
				return 5
			}

			// 7 -> 选择了原件 + 资质 非分行 + 公司印章
			if (!isIncludeBranch && isCompanySeal) {
				console.log("7 -> 选择了原件 + 资质 非分行 + 公司印章")
				return 7
			}

			// 8 -> 选择了原件 + 资质 包含分行 + 公司印章
			if ((isIncludeBranch && !isOnlyBranch) && isCompanySeal) {
				console.log("8 -> 选择了原件 + 资质 包含分行 + 公司印章 流程图中归类为10")
				// return 8
				return 10
			}
			// 9 -> 选择了原件 + 资质 包含分行
			if (isIncludeBranch && !isOnlyBranch) {
				console.log("9 -> 选择了原件 + 资质 包含分行 流程图中归类为10")
				// return 9
				return 10
			}

			// 10 -> 选择了原件 + 资质 仅分行 + 公司印章
			if (isOnlyBranch && isCompanySeal) {
				console.log("10 -> 选择了原件 + 资质 仅分行 + 公司印章 流程图中归类为10")
				return 10
			}

			// 11 -> 选择了原件 + 仅分行
			if (isOnlyBranch) {
				console.log("11 -> 选择了原件 + 仅分行")
				return 11
			}
		},
		submit() {
			let that = this;

			// if (isSubmit) {
			// 	that.$message.info("已提交");
			// 	return;
			// }
			// 是否选择了分行
			var isLicense = 0;
			var isYzLicense = false;
			// 是否选择了资质
			var isZz = 0;
			// 是否选择了印章
			var isYz = false;
			// 选择非分行
			var isOther = 0;
			var condition = 0;

			var controls = that.templateData.TemplateContent.Controls;
			controls.forEach(item => {
				if (item.Property.Title[0].Text == "委托部门") {
					item.Placeholder = "风险管理部";
				}
				if (item.Property.Title[0].Text == "流程条件") {
					item.Value = item.Value.toString();
				}
			});
			for (var i = 0; i < controls.length; i++) {
				if (controls[i].Property != null && controls[i].Property.Require == 1 && (controls[i].Value == null && controls[i]
					.Values == null)) {
					alert(controls[i].Property.Title[0].Text + "未填写,请填写完整");
					isSubmit = false;
					return;
				}
				if (controls[i].Property.Control == "Table") {
					var childrens = controls[i].Config.Table.Children;
					for (var j = 0; j < childrens.length; j++) {
						if (childrens[j].Property.Require == 1 && ((childrens[j].Value == null || childrens[j].Value == '') && (
							childrens[j].Values == '' || childrens[j].Values == null))) {
							that.$message.error(childrens[j].Property.Title[0].Text + "未填写,请填写完整");
							isSubmit = false;
							return;
						}
						var items = [];
						if (childrens[j].Property.Title[0].Text.indexOf("类型") > -1 && childrens[j].Values != null) {
							if (childrens[j].Values.length > 0) {
								if (childrens[j - 1].Value == null || childrens[j - 1].Value.length == 0) {
									that.$message.error(childrens[j - 1].Property.Title[0].Text + "未填写,请填写完整");
									return;
								}
							}
							for (var y = 0; y < childrens[j].Values.length; y++) {
								items.push(childrens[j].Values[y]);
							}
						}
						// if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text.indexOf("资质")>-1 ) {
						// 	if (childrens[j].Property.Title[0].Text.indexOf("公司") > -1 && childrens[j].Value != null) {
						// 		let options = childrens[j].Config.Selector.Options;
						// 		items = [];
						// 		if (childrens[j].Value != null && childrens[j].Value.length > 0) {
						// 			isZz++;
						// 			for (var y = 0; y < options.length; y++) {
						// 				if (options[y].Key == childrens[j].Value && options[y].Value[0].Text.indexOf("分行") > -1) {
						// 					isLicense++;
						// 				}else if(options[y].Key == childrens[j].Value){
						// 					isOther++;
						// 				}
						// 			}
						// 		}
						// 	}
						// }
						// if (that.templateData.TemplateContent.Controls[i].Property.Title[0].Text.indexOf("印章")>-1) {
						// 	if (childrens[j].Property.Title[0].Text.indexOf("公司") > -1 && childrens[j].Value != null) {
						// 		let options = childrens[j].Config.Selector.Options;
						// 		items = [];
						// 		if (childrens[j].Value != null && childrens[j].Value.length > 0) {
						// 			isYz = true;
						// 			for (var y = 0; y < options.length; y++) {
						// 				if (options[y].Key == childrens[j].Value && options[y].Value[0].Text.indexOf("分行印章") > -1) {
						// 					isYzLicense = true;
						// 				}else if(options[y].Key == childrens[j].Value){
						// 					isOther = true;
						// 				}
						// 			}
						// 		}
						// 	}
						// }
					}
				}
			}

			condition = that.getApprovalCriteria(that.templateData.TemplateContent)
			const conditionComponent = controls.filter(e => e.Property.Title[0].Text === "流程条件")[0]
			conditionComponent.Value = condition + ""

			var SummaryList = [];
			var info = {
				SummaryInfo: []
			}
			info.SummaryInfo = [];

			var control1 = this.templateData.TemplateContent.Controls.filter(t => {
				return t.Property.Title[0].Text == "借用类型"
			})[0];
			var control1Text = control1.Config.Selector.Options.filter(t => {
				return t.Key == control1.Value
			})[0].Value[0].Text;
			var info = {
				SummaryInfo: []
			}
			info.SummaryInfo = [];
			info.SummaryInfo.push({
				"Text": "借用类型：" + control1Text,
				"Lang": "zh_CN"
			});
			SummaryList.push(info);

			var control2 = this.templateData.TemplateContent.Controls.filter(t => {
				return t.Property.Title[0].Text == "部门"
			})[0]
			var info = {
				SummaryInfo: []
			}
			info.SummaryInfo = [];
			info.SummaryInfo.push({
				"Text": "申请部门：" + control2.Value,
				"Lang": "zh_CN"
			});
			SummaryList.push(info);

			var control3 = this.templateData.TemplateContent.Controls.filter(t => {
				return t.Property.Title[0].Text == "申请时间"
			})[0]
			var info = {
				SummaryInfo: []
			}
			info.SummaryInfo = [];
			info.SummaryInfo.push({
				"Text": "申请时间：" + control3.Value,
				"Lang": "zh_CN"
			});
			SummaryList.push(info);
			this.templateData.SummaryList = SummaryList;

			isSubmit = true;
			// 提交
			submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
				isSubmit = false;
				this.$router.push("/index");
				console.log(response);
			})
		}
	}
}
</script>

<style scoped lang="less">
.pages {
	padding-bottom: 14px;
}
</style>
